export default __webpack_public_path__ + "static/media/lt_gen_elias_rodrigues_martins_filho.e53060ce.m4a";